<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">在线文档</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">
            数据类型：<span>X-WWW-FORM-URLENCODED </span>
          </p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from '../components/onlineDoc'
export default {
  components: { onlineDoc },
  data() {
    return {
      onlineData: {
        //接口描述
        apiDesc: '与平台签约的客户，可通过此接口接收干线加班车招采的订单',
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'tenderNo',
                type: 'String(30)',
                require: 'Y',
                normal: '',
                describe: '需求编码'
              },
              {
                name: 'messageType',
                type: 'Integer',
                require: 'Y',
                normal: '1',
                describe: `消息类型 ：<br />1-定标 <br />2-废标 <br />3-定标取消<br/>4-开标(定标中)<br/>5-流标<br/>6-未中标`
              },
              {
                name: 'winPrice',
                type: 'BigDecimal',
                require: 'N',
                normal: '',
                describe: '中标价格'
              },
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              },
              {
                name: 'data',
                type: 'Object',
                require: 'Y',
                normal: '',
                describe: '业务数据'
              }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1362
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"tenderNo":"XQBM202408270006","messageType":1}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success"
}
`),
        //错误代码提示
        errcodeJson: []
      }
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
